<template>
  <div>
    <v-dialog v-model="value" max-width="700px" scrollable persistent>
      <v-form @submit.prevent="save()" ref="form" :lazy-validation="true" :disabled="isLoading">
        <v-card>
          <v-card-title class="
              d-flex
              justify-space-between
              align-center
              success lighten-4
              py-2
            ">
            <div>{{ $t('income.add_income') }}</div>
            <v-btn icon @click="dismiss()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class=" py-5">
            <v-row class="pt-3">
              <v-col cols="12" class="py-0">
                <v-menu v-model="menuDueDate" :close-on-content-click="false" transition="scale-transition" offset-y
                  max-width="290px" min-width="auto" :disabled="mode == 'view'">
                  <template v-slot:activator="{ on, attrs }">
                    <div>{{ $t('income.income_date') }}</div>
                    <v-text-field :value="$helper.datelabel(formData.date)" :placeholder="$t('date')" outlined readonly
                      v-bind="attrs" v-on="on" :disabled="mode == 'view'">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="formData.date" no-title locale="th" @input="menuDueDate = false"
                    :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                    :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="py-0">
                <div>{{ $t('detail') }}</div>
                <v-textarea v-model="formData.detail" outlined :placeholder="$t('detail')" :rules="[rules.required]" rows="3"
                  :disabled="mode == 'view'"></v-textarea>
              </v-col>
              <v-col cols="12" class="py-0">
                <div>{{ $t('category') }}</div>
                <v-combobox v-model="formData.category" outlined :placeholder="$t('category')" :rules="[rules.required]"
                  :items="categories || []" :disabled="isloadData || mode == 'view'" item-value="name" item-text="name"
                  @input="addCategory($event, (formData.category.objectId ? false : true))">
                  <template v-slot:selection="item">
                    {{ formData.category ? formData.category.name : '-' }}
                    <v-chip small color="error"
                      v-if="formData.category && formData.category.isRemoved">{{ $t('category_deleted') }}</v-chip>
                    <v-tooltip top v-if="formData.category && formData.category.isNew">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <v-chip small color="info">{{ $t('payment.new_list') }}</v-chip>
                        </div>
                      </template>
                      <div>{{ $t('payment.new_category_when_save_will_create_new_category_automatically') }}</div>
                    </v-tooltip>
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12" class="py-0">
                <div>{{ $t('contract.contract_number_only') }}</div>
                <v-autocomplete v-model="formData.contractId" outlined :placeholder="$t('contract.contract_number_only')" :items="contracts"
                  item-value="objectId" :item-text="(r) => `${r.contractId} (${r.businessName})`" clearable
                  :disabled="isloadData || mode == 'view'"></v-autocomplete>
              </v-col>

              <v-col cols="12" class="py-0">
                <div class="d-flex justify-space-between">
                  <div></div>
                  <v-checkbox v-model="formData.isVatInclusive" class="mt-0 mb-1 small-checkbox" :label="$t('payment.price_not_include_vat')"
                    hide-details :true-value="false" :false-value="true" @change="calTotalVatValue()"
                    :disabled="mode == 'view'" />
                </div>
              </v-col>
              <v-col cols="5" class="py-0">
                <div>{{ $t('payment.amount') }}</div>
                <v-currency-field v-model="formData.originalPrice" outlined :placeholder="$t('payment.amount')" :rules="[rules.required]"
                  class="input-disable-appearance input-right" dense :disabled="mode == 'view'"
                  @input="calTotalVatValue()" />
              </v-col>
              <v-col cols="3" class="py-0">
                <div>{{ $t('tax.vat_if_have') }}</div>
                <v-currency-field v-model="formData.vatPercent" outlined :placeholder="$t('tax.tax_vat')"
                  class="input-disable-appearance" suffix="%" dense :disabled="mode == 'view'"
                  @input="calTotalVatValue()" />
              </v-col>
              <v-col cols="4" class="py-0">
                <div>{{ $t('tax.total_vat_value') }}</div>
                <v-currency-field v-model="formData.totalVatValue" outlined :placeholder="$t('tax.total_vat_value')"
                  class="input-disable-appearance input-right" dense :disabled="mode == 'view'"
                  @input="calTotalValue()" />
              </v-col>

              <v-col cols="5" class="py-0">
                <div>{{ $t('market.total_net_income', { count: '' }) }}</div>
                <v-currency-field v-model="formData.totalValue" outlined :placeholder="$t('market.total_net_income', { count: '' })" :rules="[rules.required]"
                  class="input-disable-appearance input-right" dense :disabled="mode == 'view'"
                  @input="calTotalWhtValue()" />
              </v-col>
              <v-col cols="3" class="py-0">
                <div>{{ $t('tax.tax_withholding_if_have') }}</div>
                <v-currency-field v-model="formData.whtPercent" outlined :placeholder="$t('tax.tax_withholding')"
                  class="input-disable-appearance" suffix="%" dense :disabled="mode == 'view'"
                  @input="calTotalWhtValue()" />
              </v-col>
              <v-col cols="4" class="py-0" v-if="formData.whtPercent">
                <div>{{ $t('tax.total_wht_value') }}</div>
                <v-currency-field v-model="formData.totalWhtValue" outlined :placeholder="$t('tax.total_wht_value')"
                  :rules="[rules.required]" class="input-disable-appearance input-right" dense
                  :disabled="mode == 'view'"></v-currency-field>
              </v-col>
              <v-col cols="12" class="py-0 ">
                <div class="text-center d-block mb-3">
                  <h4 class="text-center">
                    {{ $t('market.total_value') }} <b>{{ (formData.totalValue || 0) | currencySuffixTextThEn }}</b>
                  </h4>
                  <p class="text-center py-0 my-0" v-if="formData.whtPercent">
                    {{ $t('tax.tax_withholding') }}<b>{{ (formData.totalWhtValue || 0) | currencySuffixTextThEn }}</b>
                  </p>
                  <h1 class="text-center" v-if="formData.whtPercent">
                    {{ $t('payment.remaining_amount_payment') }} <b>{{ (formData.totalValue || 0) - (formData.totalWhtValue || 0) | currencySuffixTextThEn }}</b>
                  </h1>
                </div>
              </v-col>
              <v-col cols="12" class="py-0">
                <div>{{ $t('proof') }}</div>
                <v-file-input v-model="fileInput1" @change="uploadFile($event, formData.proofOfPayment)" outlined multiple
                  :placeholder="$t('proof')" :disabled="mode == 'view' || isUploadImage"></v-file-input>
                <template v-if="formData.proofOfPayment && formData.proofOfPayment.length">
                  <div class="mx-5 mb-5">
                    <div v-for="(image, index) in formData.proofOfPayment" :key="index" class="img-box">
                      <v-icon v-if="mode == 'edit'" color="red"
                        @click="formData.proofOfPayment.splice(index, 1)">mdi-close</v-icon>
                      <img :src="image.url" :alt="`image-proof-of-payment-upload-${index}`"
                        @click="clickImage(image.url)" />
                    </div>
                  </div>
                </template>
              </v-col>
              <v-col cols="12" class="py-0">
                <div>{{ $t('important_paper') }}</div>
                <v-file-input v-model="fileInput2" @change="uploadFile($event, formData.paymentVoucher)" outlined multiple
                  :placeholder="$t('important_paper')" :disabled="mode == 'view' || isUploadImage"></v-file-input>
                <template v-if="formData.paymentVoucher && formData.paymentVoucher.length">
                  <div class="mx-5 mb-5">
                    <div v-for="(image, index) in formData.paymentVoucher" :key="index" class="img-box">
                      <v-icon v-if="mode == 'edit'" color="red"
                        @click="formData.paymentVoucher.splice(index, 1)">mdi-close</v-icon>
                      <img :src="image.url" :alt="`image-payment-voucher-upload-${index}`"
                        @click="clickImage(image.url)" />
                    </div>
                  </div>
                </template>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn v-if="mode == 'view'" color="error" elevation="0" :disabled="isLoading" @click="isRemoveDialog = true">
              <v-icon left>mdi-trash-can</v-icon>{{ $t('action_type.delete') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="default" elevation="0" @click="dismiss()">{{ $t('close') }}</v-btn>
            <v-btn v-if="mode == 'view'" color="warning" elevation="0" :disabled="isLoading" @click="editMode()">
              <v-icon left>mdi-pencil</v-icon>{{ $t('action_type.edit') }}
            </v-btn>
            <v-btn v-show="mode == 'edit'" color="success" type="submit" elevation="0"
              :disabled="isLoading || isloadData">
              <v-icon left>mdi-content-save</v-icon>{{ $t('save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <ConfirmDialog v-model="isRemoveDialog" :title="$t('validate.you_want_to_delete_list')" :textBtnOk="$t('confirm')" :textBtnCancel="$t('close')"
          type="error" @onOk="onRemove()" />
      </v-form>

    </v-dialog>
    <v-snackbar v-model="isSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
    </v-snackbar>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
  </div>
</template>

<script>
import { Contract, TransactionCategory, FileUpload } from "../classes";
import ConfirmDialog from "@/components/ConfirmDialog.component";
export default {
  props: {
    value: Boolean, // v-model from root,
    marketId: String,
    projectId: String,
    income: Object
  },
  components: {
    ConfirmDialog,
  },
  watch: {
    value(r) {
      if (r) {
        this.initData()
        this.prepareFormData();
      }
    },
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('validate.please_input_data'),
      },
      formData: {},
      isLoading: false,
      isloadData: false,
      isError: false,
      isSuccess: false,
      menuDueDate: false,
      contracts: [],
      mode: "view",
      isUploadImage: false,
      fileInput1: null,
      fileInput2: null,
      isRemoveDialog: false,
      categories: null
    };
  },
  methods: {
    async initData() {
      this.isloadData = true
      try {
        this.contracts = await Contract.getActiveContractByMarket({
          marketId: this.marketId,
          select: ["contractId", "businessName"]
        })
        this.categories = await this.$store.dispatch("transactionCategory/getTransactionCategoryByProject", {
          projectId: this.projectId
        });
        if (this.formData.categoryObject && !this.categories.find(d => d.objectId == this.formData.categoryObject.objectId)) {
          this.categories.push(new TransactionCategory(this.formData.categoryObject))
        }
        this.isloadData = false
      } catch (err) {
        this.isError = true
        this.isloadData = false
      }
    },
    dismiss() {
      this.$emit("input", false);
    },
    prepareFormData() {
      if (this.$refs.form) this.$refs.form.resetValidation();
      if (this.income) {
        this.mode = "view"
        this.formData = {
          id: this.income.objectId,
          date: this.$moment(this.income.date.iso).format("YYYY-MM-DD"),
          detail: this.income.detail || "",
          totalValue: this.income.totalValue || null,
          category: this.income.category,
          contractId: this.income.contract?.objectId || null,
          proofOfPayment: this.income.proofOfPayment || [],
          paymentVoucher: this.income.paymentVoucher || [],
          isVatInclusive: this.income.isVatInclusive,
          vatPercent: this.income.vatPercent || null,
          whtPercent: this.income.whtPercent || null,
          originalPrice: this.income.originalPrice || null,
          totalVatValue: this.income.totalVatValue || null,
          totalWhtValue: this.income.totalWhtValue || null,
          categoryObject: this.income.category,
        };
      } else {
        this.mode = "edit"
        this.formData = {
          marketId: this.marketId,
          date: this.$moment().format("YYYY-MM-DD"),
          detail: "",
          category: null,
          contractId: null,
          proofOfPayment: [],
          paymentVoucher: [],
          isVatInclusive: true,
          vatPercent: null,
          whtPercent: null,
          originalPrice: null,
          totalVatValue: null,
          totalValue: null,
          totalWhtValue: null,
        };
      }
    },
    clickImage(url) {
      window.open(url, '_blank')
    },
    editMode() {
      this.mode = "edit"
    },
    async uploadFile(images, to = []) {
      if (images && images.length) {
        try {
          this.isUploadImage = true;
          for (const image of images) {
            const data = await FileUpload.upload(image);
            to.push(data);
          }
          this.fileInput1 = null
          this.fileInput2 = null
          this.isUploadImage = false;
        } catch (err) {
          this.isUploadImage = false;
        }
      }
    },
    async onRemove() {
      this.isLoading = true;
      try {
        let data = await this.$store.dispatch("income/removeIncome", this.formData.id);
        this.isLoading = false;
        this.isSuccess = true
        this.$emit("onSaveSuccess", data);
        this.$emit("input", false);
      } catch (error) {
        this.isLoading = false;
        this.$emit("onError", error);
      }
    },
    calTotalVatValue() {
      let originalPrice = parseFloat(this.formData.originalPrice || 0)
      let vatPercent = parseFloat(this.formData.vatPercent || 0)

      let vat = 0
      if (this.formData.isVatInclusive) {
        vat = (originalPrice * vatPercent) / (100 + vatPercent)
      } else {
        vat = (originalPrice * vatPercent) / 100
      }
      if (this.formData.vatPercent || this.formData.vatPercent === 0) {
        this.formData.totalVatValue = this.$helper.round(vat)
      } else {
        this.formData.totalVatValue = null
      }
      this.calTotalValue()
    },
    calTotalValue() {
      let originalPrice = parseFloat(this.formData.originalPrice || 0)
      if (this.formData.isVatInclusive) {
        this.formData.totalValue = originalPrice || 0
      } else {
        this.formData.totalValue = (originalPrice || 0) + parseFloat(this.formData.totalVatValue || 0)
      }
      this.calTotalWhtValue()
    },
    calTotalWhtValue() {
      let totalValue = parseFloat(this.formData.totalValue || 0)
      let totalVatValue = parseFloat(this.formData.totalVatValue || 0)
      let whtPercent = parseFloat(this.formData.whtPercent || 0)
      let nonVat = totalValue - totalVatValue

      if (this.formData.whtPercent || this.formData.whtPercent === 0) {
        this.formData.totalWhtValue = this.$helper.round(nonVat * (whtPercent / 100))
      } else {
        this.formData.totalWhtValue = null
      }
    },
    async save() {
      setTimeout(async () => {
        if (this.$refs.form.validate()) {
          this.isLoading = true;
          try {
            let data;
            let postData = {}
            postData.marketId = this.marketId
            postData.date = this.$moment(this.formData.date).startOf("day").toDate()
            postData.detail = this.formData.detail || ""
            postData.totalValue = this.formData.totalValue || 0
            if (this.formData.category) {
              if (this.formData.category.objectId) {
                postData.categoryId = this.formData.category.objectId
              } else {
                let result = this.categories.find(d => d.name == this.formData.category)
                if (result) {
                  postData.categoryId = result.objectId
                } else {
                  let category = await this.$store.dispatch("transactionCategory/createTransactionCategory", {
                    projectId: this.projectId,
                    name: this.formData.category.name
                  });
                  postData.categoryId = category.objectId
                }
              }
            }
            if (this.formData.contractId) postData.contractId = this.formData.contractId

            postData.isVatInclusive = this.formData.isVatInclusive
            if (this.formData.originalPrice) postData.originalPrice = parseFloat(this.formData.originalPrice)
            if (this.formData.vatPercent) postData.vatPercent = parseFloat(this.formData.vatPercent)
            if (this.formData.whtPercent) postData.whtPercent = parseFloat(this.formData.whtPercent)
            if (this.formData.totalVatValue) postData.totalVatValue = parseFloat(this.formData.totalVatValue)
            if (this.formData.totalValue) postData.totalValue = parseFloat(this.formData.totalValue)
            if (this.formData.totalWhtValue) postData.totalWhtValue = parseFloat(this.formData.totalWhtValue)
            if (this.formData.proofOfPayment.length) postData.proofOfPayment = this.formData.proofOfPayment
            if (this.formData.paymentVoucher.length) postData.paymentVoucher = this.formData.paymentVoucher

            if (this.formData.id) {
              postData.id = this.formData.id
              data = await this.$store.dispatch(
                "income/updateIncome",
                postData
              );
            } else {
              data = await this.$store.dispatch(
                "income/createIncome",
                postData
              );
            }

            this.isLoading = false;
            this.isSuccess = true;
            this.$emit("onSaveSuccess", data);
            this.$emit("input", false);
          } catch (error) {
            this.isError = true
            this.isLoading = false;
            this.$emit("onError", error);
            this.$emit("input", false);
          }
        }
      }, 100)
    },
    addCategory(name, isNew) {
      if (isNew) {
        let newCategory = new TransactionCategory({
          name,
          projectId: this.projectId,
          isNew: true
        })
        this.categories.push(newCategory)
        this.formData.category = newCategory
      }
    }
  },
};
</script>

<style scoped lang="scss">
.dialog-form-contract.v-dialog .dialog-form-contract-in.v-card__text::v-deep {
  max-height: calc(90vh - 65px - 64px);
}

.img-box {
  position: relative;
  width: 150px;
  height: 150px;
  display: inline-flex;
  margin: 0 5px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;

  img {
    position: relative;
    width: 100%;
    height: auto;
    object-fit: contain;
    object-position: center;
  }

  .v-icon {
    cursor: pointer;
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 2;
    padding: 5px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.08);
  }

  .v-icon:hover {
    background: rgba(0, 0, 0, 0.2);
    transform: scale(1.1);
  }

  .v-icon:focus::after {
    opacity: 0;
  }
}

.change-box {
  border: 1px solid rgba(128, 128, 128, 0.514);
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
}

h2 {
  font-size: 18px;
}

h1 {
  font-size: 22px;
}
</style>
<style>
.small-checkbox.v-input--checkbox .v-label {
  font-size: 15px;
}

.small-checkbox.v-input--checkbox .v-icon {
  font-size: 20px;
}
</style>